import { Info, List, Wrapper } from "template/ListTemplate.style";
import sketchBackColumn from "../sketchBackColumn.json";
import SketchBackMonthList from "./SketchBackMonthList";
import { ListDefault } from "components/ListDefault/ListDefault";
import { PaginationBox } from "components/Pagination/PaginationBox";
import { ExcelDownloadBtn } from "components/Buttons/ExcelDownloadBtn";
import { useToastCustom } from "hooks/useToastCustom";
import { useMutationCustom } from "hooks/useMutationCustom";
import { POST_SKETCH_BACK_FETCH } from "constants/pathConstant";
import { SKETCH_BACK_MONTH_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";
import { useExcelDownload } from "hooks/excelDownload/useExcelDownload";
import EmptyScreen from "components/EmptyScreen/EmptyScreen";

const SketchBackMonth = ({
  data,
  isSearch,
  currentPage,
  setCurrentPage,
  setSketchBackDetailRes,
  detailPage,
  searchReq,
  setSearchDetailReq,
  setIsMonthSearch,
  setChecked,
  searchDetailReq,
  setDetailPage,
  detailSize,
  txState,
  setTxState,
}) => {
  const toast = useToastCustom();
  const excelDownload = useExcelDownload();

  const { mutate } = useMutationCustom(POST_SKETCH_BACK_FETCH);

  // 엑셀 다운로드
  const handleExcelDownload = () => {
    if (!isSearch || !data?.cnt) {
      toast("다운로드할 데이터가 없습니다", "error");
      return;
    }

    const mutateData = {
      ...searchReq,
      pageSize: data?.cnt,
      currentPage: 1,
    };

    mutate(mutateData, {
      onSuccess: (response) => {
        const excelData = {
          data: response.list,
          headers: SKETCH_BACK_MONTH_XLSX_DOWNLOAD.header,
          fileName: SKETCH_BACK_MONTH_XLSX_DOWNLOAD.filename,
        };

        excelDownload(excelData);
      },

      onError: () => {
        toast("전체 데이터 조회 실패", "error");
      },
    });
  };

  return (
    <Wrapper>
      <List.TitleContainer>
        <List.Text>연월별 스케치 백 리스트</List.Text>
        <List.BtnContainer>
          <ExcelDownloadBtn onClick={handleExcelDownload} />
        </List.BtnContainer>
      </List.TitleContainer>

      <List.Container>
        {!isSearch && <ListDefault text={"연월별 목록을"} />}
        {isSearch && !data.list.length && <EmptyScreen />}
        {isSearch && !!data.list.length && (
          <>
            <List.Content>
              {sketchBackColumn.month.map((v, idx) => (
                <List.Row $ratio={v.ratio} key={idx}>
                  {v.title}
                </List.Row>
              ))}
            </List.Content>

            <Info.Wrapper>
              {data.list.map((v, idx) => (
                <SketchBackMonthList
                  key={idx}
                  data={v}
                  setSketchBackDetailRes={setSketchBackDetailRes}
                  detailPage={detailPage}
                  searchReq={searchReq}
                  setSearchDetailReq={setSearchDetailReq}
                  setIsMonthSearch={setIsMonthSearch}
                  setChecked={setChecked}
                  searchDetailReq={searchDetailReq}
                  setDetailPage={setDetailPage}
                  detailSize={detailSize}
                  txState={txState}
                  setTxState={setTxState}
                />
              ))}
            </Info.Wrapper>
          </>
        )}
      </List.Container>

      {isSearch && !!data.list.length && (
        <PaginationBox
          totalItemsCount={data.cnt}
          page={currentPage}
          setPage={setCurrentPage}
          size={6}
        />
      )}
    </Wrapper>
  );
};

export default SketchBackMonth;
